import ClaimStatus from '../model/ClaimStatus';
import m from './module';

const path = '/claim_status';
const type = 'ClaimStatus';
const claimWithdrawnStatusConstant = 'CLAIM_DECLINED_FINAL';

class ClaimStatusService {
  constructor($q, $log, APIService, DataSyncService) {
    this.$q = $q;
    this.$log = $log;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
  }

  create(data) {
    data = data || {};
    if (!data.id) {
      data.id = getProvisionalIdentifierForType("claimStatus");
      this.$log.warn("Attempt to create ClaimStatus with no ID. Setting provisional ID:", data.id);
    }
    const model = new ClaimStatus(data);
    return this.$q.when(model);
  }

  getAll(config = null) {
    return this.DataSyncService.getMultipleObjects(type, path, data => this.create(data), config);
  }

  getById(id, config = null) {
    return this.DataSyncService.getObjectByIdFromMultiple(type, path, id, data => this.create(data), config);
  }

  getByConstant(key) {
    return this.getAll()
      .then(claims => claims.find(claim => claim.constant === key));
  }

  getWithdrawnStatus() {
    return this.getByConstant(claimWithdrawnStatusConstant);
  }
}

export default ClaimStatusService;

m.service('ClaimStatusService', ClaimStatusService);
